import { useEffect } from 'react';

const usePureCounter = () => {
  useEffect(() => {
    let cancelled = false;
    import('@srexi/purecounterjs')
      .then((mod) => {
        if (cancelled) return;
        const PureCounter = mod.default || mod;
        new PureCounter();
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
};

export default usePureCounter;
